import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatMenuModule } from '@angular/material/menu'
import { MatSelectModule } from '@angular/material/select'
import { MatTooltipModule } from '@angular/material/tooltip'
import { DirectivesModule } from '@mmx/shared'
import { TranslateModule } from '@ngx-translate/core'
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search'

import { ChargesTableFormComponent } from './charges-table-form.component'
import { DiscountMenuButtonComponent } from './discount-menu-button/discount-menu-button.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    FlexLayoutModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatTooltipModule,
    NgxMatSelectSearchModule,
    DirectivesModule,
    ReactiveFormsModule,
    TranslateModule,
    MatMenuModule,
  ],
  declarations: [ChargesTableFormComponent, DiscountMenuButtonComponent],
  exports: [ChargesTableFormComponent],
})
export class ChargesTableFormModule {}
